module.exports = __webpack_public_path__ + "img/cards.1ccc4417.svg";